import Parvus from "parvus";

export default function initGallery() {
  const prvs = new Parvus({
    gallerySelector: ".parvus-gallery",
    previousButtonIcon:
      '<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="64" height="64" rx="32" fill="#E3A495"/><path d="M37 42L27 32L37 22" stroke="#131313" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    nextButtonIcon:
      '<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="64" height="64" rx="32" fill="#E3A495"/><path d="M27 42L37 32L27 22" stroke="#131313" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    closeButtonIcon:
      '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" rx="20" fill="#E3A495"/><path d="M25 15L15 25" stroke="#131313" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 15L25 25" stroke="#131313" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  });
}
